export function dashboardPath(instanceId: string): string {
  return `/i/${encodeURIComponent(instanceId)}/dashboard`;
}

export function chatPath(instanceId: string, chatId?: string): string {
  const base = `/i/${encodeURIComponent(instanceId)}/chat`;
  return chatId ? `${base}/${encodeURIComponent(chatId)}` : base;
}
